import { CtaButton } from '@zappyrent/hundop';
import { rem, hideVisually } from 'polished';
import styled from 'styled-components/macro';

export const StyledGenerateLinkWrapper = styled.fieldset`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: ${rem('16px')};
  margin: ${rem('24px')} 0 0 0;
  padding: 0;
  border: none;
`;

export const StyledWrapper = styled.div`
  margin: ${rem('60px')} 0;

  @media screen and (min-width: ${({ theme }) => theme.breakpoints.l}) {
    margin-bottom: 0;
  }
`;

export const StyledParagraphsWrapper = styled.div`
  margin: ${rem('24px')} 0;
  display: flex;
  flex-direction: column;
  gap: ${rem('8px')};
`;

export const StyledLinkBoxWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: ${rem('8px')};
  margin-top: ${rem('16px')};
`;

export const StyledLinkBox = styled.p`
  background-color: ${({ theme }) => theme.colors.cross.lightGray};
  color: ${({ theme }) => theme.colors.cross.grayson};
  padding: ${rem('16px')};
  border-radius: ${rem('8px')};
  margin: 0;
  overflow: hidden;
  flex-grow: 1;
  text-overflow: ellipsis;
`;

export const StyledCtaButton = styled(CtaButton)`
  flex-grow: 1;
  flex-shrink: 0;
  text-transform: uppercase;
`;

export const StyledCtaButtonWrapper = styled.div`
  margin-top: ${rem('14px')};
`;

export const StyledCtaButtonsWrapper = styled.div`
  display: grid;
  grid-auto-columns: 1fr;
  grid-auto-flow: column;
  width: 100%;
  gap: ${rem('8px')};
`;

export const StyledInputFieldWrapper = styled.div`
  flex-grow: 1;
`;

export const StyledFormError = styled.span`
  display: flex;
  margin-top: ${rem('-16px')};
  color: ${({ theme }) => theme.colors.cross.red};
  font-size: ${rem('12px')};
  font-weight: 400;
`;

export const StyledSocialBoxWrapper = styled.div`
  margin-top: ${rem('32px')};
`;

export const StyledSocialBoxLink = styled.a`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${rem('36px')};
  height: ${rem('36px')};
  color: ${({ theme }) => theme.colors.main};
  background-color: ${({ theme }) => theme.colors.landlord.main};
  border-radius: ${rem('8px')};

  span {
    ${hideVisually()}
  }

  svg {
    width: 60%;
    height: 60%;

    path {
      fill: ${({ theme }) => theme.colors.main};
    }
  }
`;

export const StyledSocialBoxList = styled.ul`
  display: flex;
  flex-direction: row;
  gap: ${rem('12px')};
  margin: ${rem('8px')} 0 0 0;
  padding: 0;
`;

export const StyledSocialBoxListItem = styled.li`
  padding: 0;
  list-style: none;
`;
